import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Transporter } from '../../../models/bill-of-lading.model';

@Component({
  standalone: false,
  selector: 'app-transporter-choice-modal',
  templateUrl: './transporter-choice-modal.component.html',
  styleUrls: ['../modal.component.scss']
})

export class TransporterChoiceModalComponent {
  @Input() transporter?: Transporter | null;
  selectedTrasporterId: string | null = null;

  @Output() readonly responseChanged = new EventEmitter();

  constructor() {}

  onSelectTransporter(transporter: any) {
    if (transporter) {
      this.selectedTrasporterId = transporter.transporterId;
    }
  }
  
  emitTrue(): void {
    this.responseChanged.emit(this.selectedTrasporterId);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}